import { Injectable } from '@angular/core';

import { BigDecimalService } from '../core/services/big-decimal.service';
import { CompanyService }    from '../companies/company.service';
import { InvoiceModel }      from '../invoices/models/invoice';
import { InvoiceService }    from '../invoices/invoice.service';
import { StripeService }     from '../stripe/stripe.service';

@Injectable({
  providedIn: 'root'
})
export class WorkshopPayService {
  constructor (
    private bigDecimalService: BigDecimalService,
    private companyService   : CompanyService,
    private invoiceService   : InvoiceService,
    private stripeService    : StripeService
  ) {}

  checkout ( invoice : InvoiceModel, token ?: string ) : Promise<stripe.paymentIntents.PaymentIntent> {
    return this.stripeService.checkout(invoice, token);
  }

  isPaymentRequestAvailable ( invoice : InvoiceModel, isSale : boolean ) : boolean {
    const balance    = this.bigDecimalService.get(invoice.balance_due, 2);
    const deposits   = this.bigDecimalService.get(invoice.deposits_total, 2);
    const total      = this.bigDecimalService.get(invoice.total, 2);

    return this.companyService.hasIntegration('stripe')
      && !isSale
      && this.invoiceService.isType(invoice, 'credit')
      && this.invoiceService.isType(invoice, 'quote')
      && this.invoiceService.isStatus(invoice, 'processed')
      && balance.isPositive()
      && balance.equals(total)
      && deposits.isZero();
  }

  overrideCompanyInstance ( companyService : any ) : void {
    this.companyService = companyService;
  }
}